export const FETCH_PRICES = 'FETCH_PRICES';